import type { GateRow } from '@/api'

/** What a waiting decision is: an action (approving it runs something) or a question (answering it informs the run). */
export type GateKind = 'action' | 'question'

/** The part of a gate that decides its kind. */
export type GateKindInput = Pick<GateRow, 'toolName' | 'choices' | 'changesNothing'>

/** The tool a run raises to ask the CEO questions: answering it informs the run, it runs nothing. */
const ASK_CEO = 'os.ask_ceo'

/**
 * A gate's kind, decided here once for every surface that draws a gate (#1760), by what the CEO's controls do.
 *
 * - A gate the server flags as changing nothing is a question, whatever raised it: there is nothing to approve.
 * - `os.ask_ceo` is a question: the person accepts, answers or asks for more on each of its questions.
 * - A gate with its own choices is a question: the person picks an option, and no stored payload is shown to approve.
 * - Any other tool gate is an action: Approve runs exactly the payload the card shows.
 */
export function gateKind(gate: GateKindInput): GateKind {
    if (gate.changesNothing === true) {
        return 'question'
    }
    if (gate.toolName === ASK_CEO) {
        return 'question'
    }
    if ((gate.choices?.length ?? 0) > 0) {
        return 'question'
    }
    return 'action'
}
